<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Paragraph"> </p>
<p class="P_Paragraph"> </p>
<h1 class="P_Heading_1" id="auto_bookmark_toc_1"><span>EMERALD FIRE</span></h1>
<p class="P_Paragraph"> </p>
<p class="P_Paragraph"> </p>
<h2 class="P_Heading_2"><span>S.M. BUTLER</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?4539c21e